import {jsx as _jsx} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'
import NotificationAction from '~/components/NotificationAction'

import useRouter from '../hooks/useRouter'
import NotificationTemplate from './NotificationTemplate'





const MeetingStageTimeLimitEnd = (props) => {
  const {notification: notificationRef} = props
  const notification = useFragment(
    graphql`
      fragment MeetingStageTimeLimitEnd_notification on NotificationMeetingStageTimeLimitEnd {
        ...NotificationTemplate_notification
        id
        meeting {
          id
          name
          team {
            name
          }
        }
      }
    `,
    notificationRef
  )
  const {history} = useRouter()
  const {meeting} = notification
  const {id: meetingId, name: meetingName, team} = meeting
  const {name: teamName} = team
  const goThere = () => {
    history.push(`/meet/${meetingId}`)
  }

  return (
    _jsx(NotificationTemplate, {
      message: `Your meeting ${meetingName} with ${teamName} is ready to move forward`,
      notification: notification,
      action: _jsx(NotificationAction, { label: 'Go to meeting', onClick: goThere,} ),}
    )
  )
}

export default MeetingStageTimeLimitEnd
